<template>
  <section class="triplea-catalog-section">
    <div class="triplea-container">
      <div class="catalog-title-row">
        <div class="col-xl-7 category-title-bloc">
          <h2>
              {{ sectionTitle }}
          </h2>
        </div>
        <div class="col-xl-5 category-button-title-bloc">
          <a href="/triplea/busca?residencial" :class="['see-all-button', theme]">
            <span>
              <img src="@/assets/img/triplea/home/top-right-arrow.svg">
            </span>
            Ver todos os imóveis
          </a>
        </div>
      </div>
      <div class="catalog-items-row">
          <carousel v-bind="carouselOptions" :key="properties.length">
              <div class="catalog-item"
                  v-for="property in properties" 
                  :key="property.referencia"
                >
                  <a class="catalog-item-card" :href="property_url(property)" :style="{ backgroundImage: `url(${property.foto_principal || require('@/assets/img/triplea/home/property-base.png')})` }" target="_blank">
                      <div class="catalog-item-card-badges">
                          <span class="catalog-item-card-badge">{{ property.condominio }}</span>
                          <span class="catalog-item-card-badge">{{ property.cidade }}</span>
                      </div>
                      <div class="catalog-item-card-content">
                          <div class="catalog-item-card-content-top-row">
                              <h2>R$ {{ property.valor_considerado.toLocaleString('pt-BR') }}</h2>
                              <h4>Ref. {{ property.referencia }}</h4>
                              <div class="catalog-item-card-content-top-button">
                                  <font>Saiba mais</font>
                                  <img src="@/assets/img/triplea/home/top-right-arrow-light.svg"/>
                              </div>
                          </div>
                          <div class="catalog-item-card-content-row">
                              <div class="catalog-item-card-content-adress-bloc">
                                  <p>{{ property.endereco }}</p>
                                  <p>{{ property.bairro }}, {{ property.cidade }}</p>
                              </div>
                              <div class="catalog-item-card-content-optional-bloc">
                                  <div class="catalog-item-card-content-optional-item">
                                      <img src="@/assets/img/triplea/home/optional/space.svg" />
                                      <p>{{ property.area_total }}m²</p>
                                  </div>
                                  <div class="catalog-item-card-content-optional-item">
                                      <img src="@/assets/img/triplea/home/optional/rooms.svg" />
                                      <p>{{ property.dormitorios || 0 }} quartos</p>
                                  </div>
                                  <div class="catalog-item-card-content-optional-item">
                                      <img src="@/assets/img/triplea/home/optional/cars.svg" />
                                      <p>{{ property.garagem || 0 }} vagas</p>
                                  </div>
                                  <div class="catalog-item-card-content-optional-item">
                                      <img src="@/assets/img/triplea/home/optional/bathroom.svg" />
                                      <p>{{ property.banheiro || 0 }} banheiros</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                    </a>
              </div>
          </carousel>
      </div>
    </div>
  </section>
</template>

<script>
import "@/assets/scss/custom/triplea/components/_catalog_section.scss";
import PropertiesService from "@/services/PropertiesService";
import carousel from "vue-owl-carousel";

export default {
  components: { carousel },
  data() {
    return {
      carouselOptions: {
        items: 2,
        loop: true,
        margin: 16,
        autoplay: true,
        autoplayTimeout: 5000,
        nav: true,
        dots: true,
        navText: [
          `<img src='${require('@/assets/img/triplea/arrow-left.svg')}' alt='Prev'>`,
          `<img src='${require('@/assets/img/triplea/arrow-right.svg')}' alt='Next'>`,
        ],
        navClass: ["custom-catalog-arrow", "custom-catalog-arrow"],
        responsive: {
          0: { items: 1 },
          768: { items: 2 },
          1024: { items: 2 },
        },
      },
      properties: [],
    };
  },
  props: {
    sectionTitle: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: ''
    },
    propertyType: {
      type: String,
      require: false,
      default: 'triplea'
    }

  },
  computed: {
  },
  methods: {
    loadProperties() {
      const filters = {
        transacao: "Vendas",
        size: 12,
        fields: [
          "IsFeiraoApolar",
          "nomeEvento",
          "tipo",
          "transacao",
          "finalidade",
          "cidade",
          "bairro",
          "referencia",
          "Quartos",
          "condominio",
          "garagem",
          "dormitorios",
          "areaterreno",
          "area_total",
          "banheiro",
          "ValorAnterior",
          "valor_considerado",
          "situacao",
          "FimPromocao",
          "foto_principal",
          "endereco",
          "linksite",
          "Selo",
          "popup_fotos",
          "idtipomoeda",
        ],
      };
      console.log(this.propertyType)
      PropertiesService.customSearch(filters, this.propertyType)
      .then((response) => {
        if (response.success) {
          this.properties = response.data;
        }
      })
      .catch((error) => {
        console.error("Erro ao carregar propriedades:", error);
      });
    },
    property_url(property) {
        return this.get_property_url(property)
    },
  },
  mounted() {
    this.loadProperties();
  },
};
</script>

